import Vue from 'vue';
import Dinero from 'dinero.js/build/esm/dinero.js';
import { isNumeric } from 'dinero.js/src/services/helpers.js';
Dinero.globalLocale = 'de-DE';
Dinero.defaultCurrency = 'EUR';
Dinero.defaultPrecision = 0;
window.Dinero = Dinero;
Vue.filter('money', function (value) {
    if (isNumeric(value) && !isNaN(parseInt(value))) {
        return Dinero({ amount: parseInt(value) }).toFormat('$0,0');
    }
    return value;
});
